import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCustomer: null,
};

const customerCreditLimitSlice = createSlice({
  name: "customerCreditLimit",
  initialState,
  reducers: {
    setSelectedCreditCustomer(state, action) {
      state.selectedCustomer = action.payload;
    },
    resetCustomerCreditLimit(state) {
      state.selectedCustomer = null;
    },
  },
});

export const { setSelectedCreditCustomer, resetCustomerCreditLimit } = customerCreditLimitSlice.actions;
export default customerCreditLimitSlice.reducer;
